/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import {
  BuilderPermission,
  JobDrawsRestService,
  JobListFilterDto,
  JobRestService,
  SystemRoleBit,
} from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { DrawListItem } from './draw-list.model';
import { ENV_BASE_URL } from '@gh/config';
import { BuilderUserContext, FilterNames, FilterRestService } from '@gh/builder-shared';

@Injectable()
export class DrawListBusinessService implements InitViewService {
  COLUMN_ENABLE_CONDITION = {
    totalAmount: (): boolean => this.getCountry() !== 'us',
    estimatedProfit: (): boolean => this.getPermissionForPrices(),
    profitMargin: (): boolean => this.getPermissionForPrices(),
    drawsMadeWithGst: (): boolean => this.getPermissionForPricesExtended(),
    actualProfit: (): boolean => this.getPermissionForPrices(),
  };

  constructor(private jobRest: JobRestService,
              private drawsRest: JobDrawsRestService,
              private userContext: BuilderUserContext,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      gridLayout: this.gridLayoutService.get('drawList', this.COLUMN_ENABLE_CONDITION),
      filter: this.filterService.get(FilterNames.drawList),
    };
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<DrawListItem> {
    return this.drawsRest.findAllAsDataSource(filter);
  }

  getCountry(): string {
    const baseUrl = ENV_BASE_URL.toString();
    switch (true) {
      case baseUrl.includes('-au') || baseUrl.includes('.au'):
        return 'au';
      case baseUrl.includes('-nz') || baseUrl.includes('.nz'):
        return 'nz';
      case baseUrl.includes('-us') || baseUrl.includes('.com'):
        return 'us';
      default:
        return 'us';
    }
  }

  getPermissionForPrices(): boolean {
    return this.userContext.hasSystemRole(SystemRoleBit.Corporate)
      || this.userContext.hasSystemRole(SystemRoleBit.Master)
      || this.userContext.hasPermission(BuilderPermission.Estimating.JobEstimate.EDIT)
      || this.userContext.hasPermission(BuilderPermission.Estimating.JobEstimate.VIEW)
      || this.userContext.hasPermission(BuilderPermission.JobAdmin.Financials.VIEW);
  }

  getPermissionForPricesExtended(): boolean {
    return this.getPermissionForPrices()
      || this.userContext.hasPermission(BuilderPermission.Accounting.Draws.VIEW)
      || this.userContext.hasPermission(BuilderPermission.Accounting.Draws.PRODUCE);
  }
}
